// Package imports:
import React from 'react';
// Component imports:
import SearchPage from '../../components/SearchPage/SearchPage';
import Entrypoint from '../Entrypoint';

interface IOwnProps {
    term?: string | null
}

const Search: React.FC<IOwnProps> = ({
    term
}) => {
    return (
        <Entrypoint>
            <SearchPage term={term}/>
        </Entrypoint>
    );
}

export default Search;